import api from '../../plugins/api';

const getDealDocuments = (params) => {
  return api.get('/api/crm/deals/getDealDocuments', params);
};

export default getDealDocuments;
